export const environment = {
    baseUrl:'https://dev.api.noblequote.com'
};
